import React from 'react';
import clsx from 'clsx';
import { format } from 'date-fns';

import Row from '@common/Row';
import Link from '@common/Link';

const Loading = ({ show, index }) => {
  return (
    <div className={clsx('col h-100', show ? `pop-in`:`pop-out`)}>
      <div className='p-0 shadow placeholder-glow' style={{width: '100%', height: '110%'}}>
        <div className='placeholder' style={{backgroundColor: 'grey', height: '238px', width: '100%'}}/>
        <div className='p-2'>
          <div className='d-flex justify-content-between mb-3'>
            <span className='placeholder col-2' style={{minHeight: '14px'}}></span>
            <span className='placeholder col-2' style={{minHeight: '14px'}}></span>
          </div>
          <p className='d-flex flex-wrap mb-0'>
            {index %2 == 0 ?
              <>
                <span className='placeholder col-3 me-1 mb-1' style={{minHeight: '19px'}}></span>
                <span className='placeholder col-5 me-1 mb-1' style={{minHeight: '19px'}}></span>
                <span className='placeholder col-4 me-1 mb-1' style={{minHeight: '19px'}}></span>
              </>
              :
              <>
                <span className='placeholder col-6 me-1 mb-1' style={{minHeight: '19px'}}></span>
                <span className='placeholder col-2 me-1 mb-1' style={{minHeight: '19px'}}></span>
                <span className='placeholder col-4 me-1 mb-1' style={{minHeight: '19px'}}></span>
              </>
            }
          </p>
        </div>
      </div>
    </div>
  )
}

const ArticleCard = ({ data }) => {
  const { link, featuredImage, categories, title, date, author } = data || {};
  return (
    <div className='d-flex flex-column p-1 scale-1-img'>
      <Link to={`/blog${link}`}>
        <div className='rounded overflow-hidden mb-1'>
          <img src={featuredImage?.node.sourceUrl} className='img-scale w-100' alt=''/>
        </div>        
      </Link>
      {categories &&
        <Row className='mb-1'>
          {categories.nodes.map((category, index) => (
            <Link key={index} to={`/blog${category.link}`} className='col-auto text-uppercase fs-16'>
              {category.name}
            </Link>
          ))}
        </Row>
      }
      <div className='d-flex flex-column text-black flex-fill'>
        {title &&
          <Link to={`/blog${link}`} className='d-flex flex-fill'>
            <p className='text-black'>{title}</p>
          </Link>
        }
        {author &&
          <p className='fs-12 mb-0 fw-medium'>
            {format(new Date(date), 'PPP') + ` | `}<Link to={`/blog/author/${author?.node.slug}`} className='text-black'>{author?.node.name}</Link>
          </p>
        }
      </div>
    </div>
  )
}

export default Object.assign(ArticleCard, {
  Loading: Loading
});
